import { getUuid } from '../../helpers/';
import fetchJson from '../fetch/fetch-json';

const loadNotifications = async (): Promise<void> => {
	await fetchJson(`/events/notification?uuid=${getUuid()}`, { method: 'POST' });
};

export default { loadNotifications };
